<template>
	<el-dialog :title="title" :visible.sync="dialogVisible" :modal-append-to-body="false" width="618px" class="im-route-detail"
	 :close-on-click-modal="false">
		<el-form :model="form" :rules="rules" label-width="100px" ref="form">
			  <el-form-item label="优先组名称" prop="skillName">
			    <el-input v-model="form.skillName" placeholder="请输入优先组名称" size="small"></el-input>
			  </el-form-item>
			  <el-form-item label="优先级" prop="num">
			     <el-input-number v-model="form.num" :min="1" size="small"></el-input-number>
			  </el-form-item>
			  <el-form-item class="btn">
				   <el-button size="small" @click="dialogVisible = false">取消</el-button>
			      <el-button type="primary" @click="onSubmit" size="small">{{title == '编辑优先组' ? '立即修改' : '立即创建'}}</el-button>
			  </el-form-item>
		</el-form>
	 </el-dialog>
</template>

<script>
	import tableBox from './table.vue'
	export default {
		props:['lists'],
		components: {
			tableBox
		},
		data(){
			return {
				dialogVisible:false,
				form:{
					skillName:'',
					num:1,
					vipGroup:''
				},
				rules:{
					 skillName: [{ required: true, message: '请输入优先组名称', trigger: 'blur' }],
				},
				title:''
				
			}
		},
		methods: {
			onSubmit() {
				this.$refs['form'].validate((valid) => {
				  if (valid) {
					  let index = this.lists.findIndex(el => el.vipGroupName == this.form.skillName);
					  if(index != -1){
						  this.$message.error('优先组名称不能重复');
						  return;
					  }
					  if(this.title == '编辑优先组') {
						  this.$emit('updateCatchList',this.form)
					  }else {
						  this.form.vipGroup = 'vip';
						  this.$emit('pushCatchList',this.form);
					  }
					   this.dialogVisible = false;
				   }
				});
			},
			onOpen(row){
				this.dialogVisible = true;
				this.title = row ? '编辑优先组' : '创建优先组';
				this.$nextTick(() => {
					this.$refs.form.resetFields();
					if(row){
						this.form = {
							skillName:row.vipGroupName,
							num:row.vipGroupLevel,
							vipGroup:row.vipGroup,
							id:row.id
						}
					}
				})
			}
		},
	}
</script>

<style lang="scss">
	.im-route-detail {
		padding: 0 20px;
		font-size: 14px;
		.btn {
			 .el-form-item__content {
				 display: flex;
				 justify-content: flex-end;
			 }
		}
	}
</style>
